import React, { Component } from 'react'

export default class DropdownScreening extends Component {
    render() {
        const { label, require, name, title, value, disable, defaultValue, fpgerror } = this.props
        const options = this.props.options && this.props.options.map(function (option, i) {
            return (
                <option defaultValue={defaultValue} key={option.value} value={option._id}>{option.label}</option>
            )
        })
        return (
            <div className="field_row_inner">
                {label ? <label className={`${require ? 'required' : null}`}>{label}</label> : ""}
                <div className="select_field relative">
                    <select disabled={disable} name={name} onChange={(e) => this.props.onChange(e)} value={value}>
                        <option selected value={''}>Select From Below</option>
                        {options}
                    </select>
                    {fpgerror ? <span className="error" style={{ color: 'red' }} >{fpgerror}</span> : ""}
                </div>
            </div>
        )
    }
}
